import React, { useEffect, useState } from 'react';
import { getAllAnswersOnQuestionAndLanguageID } from '../../data-sources/api';
import { Button, ButtonToolbar } from 'react-bootstrap';
import { AudioPlayer } from '../players/AudioPlayer';

/**
 * MultiButtons component fetches and displays a list of answers as buttons based on the provided statement and language IDs.
 * 
 * @param {number} statementID - The ID of the statement to fetch answers for.
 * @param {number} languageID - The ID of the language to fetch countries in.
 * @param {boolean} selectMultiple - Flag indicating if multiple buttons can be selected.
 * @returns {JSX.Element} A component with buttons representing answers.
 */
export function MultiButtons({ statementID, languageID, selectMultiple }) {
    const [answers, setAnswers] = useState();
    const [sweAnswers, setSweAnswers] = useState();
    const [answerAudio, setAnswerAudio] = useState();

    const [activeButtons, setActiveButtons] = useState([]);

    /**
     * Fetches the list of answers based on the statement and language IDs
     */
    const fetchAnswers = async () => {
        try {
            const response = await getAllAnswersOnQuestionAndLanguageID(statementID, languageID);
            setAnswers(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    /**
     * Fetches the list of Swedish answers based on the statement and language IDs
     */
    const fetchSweAnswers = async () => {
        try {
            const response = await getAllAnswersOnQuestionAndLanguageID(statementID, 1);
            setSweAnswers(response.data);
            console.log(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    /**
     * Handles button click events
     */
    const handleButtonClick = (answer, buttonId) => {
        setAnswerAudio(answer.answerAudio)

        if (selectMultiple) {
            setActiveButtons(prevActiveButtons => 
                prevActiveButtons.includes(buttonId)
                  ? prevActiveButtons.filter(id => id !== buttonId)
                  : [...prevActiveButtons, buttonId]
              );
        }
        else {
            setActiveButtons(prevActiveButtons => 
                prevActiveButtons.includes(buttonId) ? [] : [buttonId]
              );
        }
    }

    /**
     * Fetch answers when the statement or language ID changes.
     */
    useEffect(() => {
        if (statementID && languageID) {
            fetchAnswers();
            setSweAnswers(null);

            if (languageID !== 1) {
                fetchSweAnswers();
            }
        }
    }, [statementID, languageID]);

    return (
        <>
            {answers?.length > 0 &&
                <ButtonToolbar className="multichoice-btns">
                    {answers.map((answer, index) => (
                        <Button
                            className="multichoice-btn"
                            variant={activeButtons.includes(index) ? 'secondary' : 'outline-secondary'}
                            size="lg"
                            key={index}
                            onClick={() => handleButtonClick(answer, index)}
                        >
                            <div className="text-container">
                                {sweAnswers?.length > 0 && <p>{sweAnswers[index].answerText}</p>}
                                <p className="medium-text">{answer.answerText}</p>
                            </div>
                        </Button>
                    )
                    )}
                </ButtonToolbar>
            }

            {answerAudio && <AudioPlayer url={answerAudio} />}
        </>
    );
}